"use strict";
exports.__esModule = true;
var length_1 = require("./length");
var __1 = require("..");
exports.validateRsyPlatformId = function (value) {
    return length_1["default"](value, __1.lengthConfig.rsyPlatformId, 'ID');
};
